// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"4983ec9f","179":"a007d415","213":"0c8f1caa","219":"bb80e489","445":"09c21444","453":"d1fa110c","547":"248c6ede","624":"3136ae30","676":"388d37a6","692":"0f67b876","732":"74d40df9","824":"6c721a7a","955":"9fc1950d"}[chunkId] + ".chunk.js";
};